import { create } from 'zustand'

import { BrandInterface } from '@/types'

interface CategoriesByBrandsCatalogStateInterface {
  currentBrand: BrandInterface
  brandSearch: string
  setCurrentBrand: (currentBrand: BrandInterface) => void
  setBrandSearch: (brandSearch: string) => void
  setInitialCategoriesByBrandsCatalogStore: () => void
}

const initialState = {
  currentBrand: {} as BrandInterface,
  brandSearch: '',
}

export const useCategoriesByBrandsCatalogStore =
  create<CategoriesByBrandsCatalogStateInterface>((set) => ({
    ...initialState,
    setCurrentBrand: (currentBrand: BrandInterface) =>
      set(() => ({ currentBrand })),
    setBrandSearch: (brandSearch: string) => set(() => ({ brandSearch })),
    setInitialCategoriesByBrandsCatalogStore: () => set({ ...initialState }),
  }))
